import React, { FunctionComponent } from 'react';

const Footer: FunctionComponent = () => (
  <div className="flex flex-col lg:flex-row lg:justify-around items-center p-12 bg-black text-white">
    <p className="text-sm">&copy; 2019 StempPeers All rights reserved</p>
    <div className="mt-4 lg:mt-0">
      <i className="icon-facebook2 mr-3" />
      <i className="icon-twitter-square mr-3" />
      <i className="icon-linkedin" />
    </div>
  </div>
);

export default Footer;
